export default {
  app: {
    place: {
      address: 'Адрес',
      showOnExternalMaps: 'Отобразить на картах Google',
    },
  },
};
